"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var test_helpers_1 = require("../../lib/test-helpers");
var colors_1 = require("../../theme/colors");
var icons_1 = require("../icons");
var iconTypes = {
    add: icons_1.IconAdd,
    archive: icons_1.IconArchive,
    arrow: icons_1.IconArrow,
    arrowDropDown: icons_1.IconArrowDropDown,
    arrowDropUp: icons_1.IconArrowDropUp,
    attach: icons_1.IconAttach,
    caretLeft: icons_1.IconCaretLeft,
    chevronLeft: icons_1.IconChevronLeft,
    chevronRight: icons_1.IconChevronRight,
    circleInformation: icons_1.IconCircleInformation,
    clock: icons_1.IconClock,
    close: icons_1.IconClose,
    date: icons_1.IconDate,
    download: icons_1.IconDownload,
    edit: icons_1.IconEdit,
    external: icons_1.IconSquareExternal,
    hidePassword: icons_1.IconEyeClosed,
    mail: icons_1.IconMail,
    more: icons_1.IconMore,
    moveLeft: icons_1.IconMoveLeft,
    moveLeftRight: icons_1.IconMoveLeftRight,
    moveRight: icons_1.IconMoveRight,
    preview: icons_1.IconPreview,
    regenerate: icons_1.IconRegenerate,
    remove: icons_1.IconRemove,
    showPassword: icons_1.IconEyeOpen,
    unarchive: icons_1.IconUnarchive,
    unlink: icons_1.IconUnlink,
};
function IconButton(props) {
    var _a;
    var ariaLabel = props.ariaLabel, color = props.color, _b = props.disabled, disabled = _b === void 0 ? false : _b, elementRef = props.elementRef, href = props.href, innerRef = props.innerRef, isActive = props.isActive, onClick = props.onClick, target = props.target, propTestId = props.testId, title = props.title, type = props.type;
    var Icon = iconTypes[type];
    var classes = (0, classnames_1.default)({
        isActive: isActive,
    });
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (0, test_helpers_1.generateTestId)((0, kebabCase_1.default)((_a = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : title) !== null && _a !== void 0 ? _a : type), 'button');
    return (React.createElement(StyledAnchor, { className: classes, onClick: !disabled ? onClick : undefined, href: !disabled ? href : undefined, target: target, ref: elementRef || innerRef, "data-testid": testId, disabled: disabled, "aria-label": ariaLabel || 'Remove', title: title },
        React.createElement(Icon, { color: color })));
}
exports.IconButton = IconButton;
var StyledAnchor = styled_components_1.default.a(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: ", ";\n  color: ", ";\n  padding: 0;\n  border: 0;\n  background: none;\n  pointer-events: ", ";\n  opacity: ", ";\n  transition: background 0.3s ease, color 0.3s ease;\n\n  :global(*) {\n    cursor: pointer;\n    pointer-events: none;\n  }\n\n  :hover,\n  &.isActive {\n    background: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n"], ["\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: ", ";\n  color: ", ";\n  padding: 0;\n  border: 0;\n  background: none;\n  pointer-events: ", ";\n  opacity: ", ";\n  transition: background 0.3s ease, color 0.3s ease;\n\n  :global(*) {\n    cursor: pointer;\n    pointer-events: none;\n  }\n\n  :hover,\n  &.isActive {\n    background: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, colors_1.colors.steel[400], function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.3' : '1.0');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : colors_1.colors.steel[100]);
});
var templateObject_1;
//# sourceMappingURL=index.js.map